<template>
  <div class="action_input_wrapper" :class="{ disabled: disabled, focus: isFocus }">
    <input ref="inputRef" :value="modelValue" :type="type" :step="step" :min="min" :max="max" :disabled="disabled" @input="onInput" @blur="onBlur" @focus="onFocus" @keydown.enter="onEnter" />
    <span v-if="unit" class="unit">{{ unit }}</span>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

const props = defineProps<{
  modelValue: string | number
  type?: string
  step?: string | number
  min?: string | number
  max?: string | number
  disabled?: boolean
  unit?: string
}>()

const emit = defineEmits(['update:modelValue', 'blur', 'focus', 'enter'])

const isFocus = ref(false)
const inputRef = ref<HTMLInputElement | null>(null)

const onInput = (e: Event) => {
  const val = (e.target as HTMLInputElement).value
  emit('update:modelValue', props.type === 'number' ? Number(val) : val)
}

const onFocus = (e: FocusEvent) => {
  isFocus.value = true
  emit('focus', e)
}

const onBlur = (e: FocusEvent) => {
  isFocus.value = false
  emit('blur', e)
}

const onEnter = (e: KeyboardEvent) => {
  ;(e.target as HTMLInputElement).blur()
  emit('enter', e)
}
</script>

<style lang="less" scoped>
.action_input_wrapper {
  display: inline-flex;
  align-items: center;
  background: var(--color-gray-1);
  border: 1px solid rgba(0, 0, 0, 0.02);
  border-radius: var(--radius-s);
  padding: 0 10px;
  height: 30px;
  width: 100%;
  min-width: 60px;
  max-width: 120px;
  transition: var(--transition-base);

  &.focus {
    border-color: var(--brand-color-pure);
    box-shadow: 0 0 0 2px rgba(var(--color-brand-1-rgb), 0.1);
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    * {
      cursor: not-allowed;
    }
  }

  input {
    width: 100%;
    background: transparent;
    border: none;
    outline: none;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    color: var(--color-dark);
    font-family: 'JetBrains Mono', 'Segoe UI', system-ui, sans-serif;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .unit {
    font-size: 12px;
    color: var(--color-text-hint);
    margin-left: 2px;
    font-weight: 600;
  }
}
</style>
